import moment from 'moment';

export const formatN = n => (n > 9 ? n : `0${n}`);

export const durationTime = (start, end) => {
  const { days, hours, minutes, seconds } = moment.duration(
    moment(end) - moment(start)
  )._data;

  return `${days}.${hours}:${minutes}:${seconds}`;
};

export const formatDuration = (value = '') => {
  const itemSplit = value?.split('.');
  return Number(itemSplit[0]) > 0
    ? value
        ?.split('.', 2)
        ?.toString()
        ?.replace(',', ' dias, ')
    : itemSplit[1]?.toString();
};

export const formatarDataCorrida = (data, abreviar) => {
  const isD = data?.split('.')[0];
  const dFormatada = abreviar ? ' d, ' : `${isD > 1 ? ' dias,' : ' dia,'} `;
  return data?.split('.')?.length >= 3
    ? data
        ?.split('.', 2)
        ?.toString()
        ?.replace(',', dFormatada)
    : data?.split('.', 1)?.toString();
};
